import inject from "scripts/ioc/inject";
import BaseFormView from "scripts/views/baseFormView";
import BaseModel from "scripts/models/baseModel";
import { fetchOrganizationUserUsingPatronCredentials } from "scripts/utils/securityHelpers";

import template from "templates/patronVerificationForm.hbs";

class PatronVerificationFormView extends BaseFormView {
  constructor(options, securityService = inject("securityService")) {
    super(options);

    this.securityService = securityService;

    this.organizationId = options.organizationId;
    this.organizationName = options.organizationName;
    this.pinRequired = options.pinRequired;

    const constraints = {
      cardNumber: {
        presence: true,
      },
    };

    if (this.pinRequired) {
      constraints.pin = {
        presence: true,
      };
    }

    this.bindModel(
      new BaseModel(
        {},
        {
          constraints: this.constraints,
        },
      ),
    );
  }

  get events() {
    return {
      "blur form *[name]": "onBlurValidate",
      "input form *[name]": "onInputEnableSubmit",
      "submit form": "onSubmit",
    };
  }

  render() {
    this.$el.html(
      template({
        organizationName: this.organizationName,
        pinRequired: this.pinRequired,
      }),
    );

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    return this;
  }

  doSubmit() {
    return fetchOrganizationUserUsingPatronCredentials({
      authScope: this.securityService.authScope,
      organizationId: this.organizationId,
      cardNumber: this.model.get("cardNumber"),
      pin: this.model.get("pin"),
      userAgent: navigator.userAgent,
    });
  }

  onSubmitFailed(error) {
    this.enableSubmit(true);
    this.trigger("failure", error);
  }
}

export default PatronVerificationFormView;
